/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

const queryParams = z.strictObject({ language: ZodTypes.Language });

export const DatasetGet = {
  id: 'dataset.get',
  tag: 'Inventory',
  summary: 'Get Dataset',
  description: 'Get dataset',
  method: 'get',
  flags: { isAuthorized: true },
  route: () => `/dataset`,
  request: {
    query: queryParams,
  },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.array(
            z.strictObject({
              id: z.string(),
              thumbnail: z.string(),
              i18n: z.strictObject({
                title: z.string(),
                language: ZodTypes.Language,
              }),
              datasets: z
                .array(
                  z.strictObject({
                    id: z.string(),
                    name: z.string(),
                    description: z.string(),
                    schema: z.string(),
                    extensions: z.array(z.string()).nullable().optional(),
                    finalSizeMb: z.string(),
                    importSizeMb: z.string(),
                    createdAt: z.date(),
                    updatedAt: z.date(),
                  }),
                )
                .optional(),
            }),
          ),
        },
      },
    },
  },
} as const satisfies Endpoint;
